import {
    styled,
    useTheme
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
    Box,
    IconButton,
    Toolbar,
    Typography,
    Drawer,
    Container
} from "@mui/material";
import { LoadingScreen } from "./LoadingScreen";
import MuiAppBar from "@mui/material/AppBar";
import MenuIcon from '@mui/icons-material/Menu';
import { CommandsMain } from "./CommandsMain";
import { LabelsFilterSearch } from './LabelsFilterSearch';
import { Bar } from "./Bar";
import { ToolsNavigation } from "./ToolsNavigation";
import { CommandContext } from "../context/CommandContext";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Divider from "@mui/material/Divider";
import React from "react";
import ReactGA from 'react-ga';
import { Route, Routes, Link, Outlet } from 'react-router-dom';
import { TAC } from './TAC';
import { ToolErrorPage } from './ToolErrorPage';
import { SearchBar } from './GeneralSearch';
const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBarCustom = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        //width: `calc(100% - ${drawerWidth}px)`,
        paddingLeft: `${drawerWidth + 20}px`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),

    }),
}));

const FooterCustom = styled('div', {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        //width: `calc(100% - ${drawerWidth}px)`,
        paddingLeft: `${drawerWidth + 20}px`,
        // marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),

    }),
}));


const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));


export const MainWindow = () => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);

    return (
        <>
            {/* <Box sx={{ display: "flex", background: "#F5F5F5", height:"100vh" }}> */}
            <Box sx={{ display: "flex", flexGrow: 1 }} className="App">
                <CssBaseline />
                <CommandContext>
                    <AppBarCustom position="fixed" open={open} className="appbar-syg" >
                        <Bar />
                        <Toolbar style={{ height: "100%" }}>
                            <IconButton
                                color="primary"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                sx={{ mr: 2, ...(open && { display: "none" }) }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Link to="/">
                                <Typography variant="headerAppBar" >
                                    Command Generator
                                </Typography>
                            </Link>
                            <Container>
                                <SearchBar />
                            </Container>
                        </Toolbar>
                        <LoadingScreen />
                    </AppBarCustom>
                    <Drawer
                        sx={{
                            width: drawerWidth,
                            flexShrink: 0,
                            "& .MuiDrawer-paper": {
                                width: drawerWidth,
                                boxSizing: "border-box",
                                border: "none",
                                left: '1vw',
                                background: 'transparent',
                            },
                        }}
                        variant="persistent"
                        anchor="left"
                        open={open}
                    >
                        {/* <DrawerHeader className=""> */}
                        <div className="sticky" style={{ background: "black" }}>
                            <div className="generator-title">
                                <img src='Logo DROPS.svg' />
                                <IconButton onClick={handleDrawerClose}>
                                    {theme.direction === "ltr" ? (
                                        <ChevronLeftIcon />
                                    ) : (
                                        <ChevronRightIcon />
                                    )}
                                </IconButton>
                            </div>
                            <br />
                            <div style={{ margin: ".5vw" }}>
                                <LabelsFilterSearch />
                            </div>
                        </div>

                        <div className="menu-style">
                            <Divider />
                            <ToolsNavigation />
                        </div>
                    </Drawer>
                    <Main open={open}>
                        <div style={{ height: "140px" }}></div>

                        <Routes>
                            <Route path="/" element={<CommandsMain />} />
                            <Route path="/terms" element={<TAC />} />
                            <Route path="/toolerror" element={<ToolErrorPage />} />
                            <Route path="*" element={<div>404 Not Found</div>} />
                        </Routes>
                    </Main>
                </CommandContext>
            </Box>
            <FooterCustom className='footer' open={open}>
                <Typography>© 2022 DROPS.</Typography>
                <a href="https://forms.gle/F7uYkxWsW9FDNzfU9" target="_blank"><Typography>Feedback</Typography></a>
                <Link to="/terms"><Typography>Terms and Conditions</Typography></Link>
            </FooterCustom>
            <Outlet />

        </>
    )
}